import React from 'react'

const IconLogoSimple = ({ width = '32', height = '32' }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Search-Example---No-Results-Found" transform="translate(-402.000000, -233.000000)" fillRule="nonzero">
        <g id="Group" transform="translate(401.000000, 232.000000)">
          <g id="Group" transform="translate(0.536591, 0.576591)">
            <polygon
              id="Rectangle"
              fill="#E21C8E"
              transform="translate(22.758186, 22.678186) rotate(45.000000) translate(-22.758186, -22.678186) "
              points="17.6317847 17.5517847 27.9163716 17.52 27.8845869 27.8045869 17.6 27.8363716"
            />
            <polygon
              id="Rectangle"
              fill="#2851A3"
              transform="translate(8.158186, 22.638186) rotate(45.000000) translate(-8.158186, -22.638186) "
              points="3.03178473 17.5117847 13.3163716 17.48 13.2845869 27.7645869 3 27.7963716"
            />
            <polygon
              id="Rectangle"
              fill="#152553"
              transform="translate(15.438186, 15.398186) rotate(45.000000) translate(-15.438186, -15.398186) "
              points="10.3117847 10.2717847 20.5963716 10.24 20.5645869 20.5245869 10.28 20.5563716"
            />
            <polygon
              id="Rectangle"
              fill="#E21C8E"
              transform="translate(22.758186, 8.158186) rotate(45.000000) translate(-22.758186, -8.158186) "
              points="17.6317847 3.03178473 27.9163716 3 27.8845869 13.2845869 17.6 13.3163716"
            />
            <polygon
              id="Rectangle"
              fill="#2851A3"
              transform="translate(8.158186, 8.158186) rotate(45.000000) translate(-8.158186, -8.158186) "
              points="3.03178473 3.03178473 13.3163716 3 13.2845869 13.2845869 3 13.3163716"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default IconLogoSimple
